import { GridCellProps } from '@progress/kendo-react-grid';
import { useTranslation } from 'react-i18next';
import NoItemIcon from 'src/assets/icons/NoItemIcon';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import { useContextSelector } from 'use-context-selector';
import { ShoppingCartContext } from '../ShoppingCartContext';

const ShoppingCartSwapItem = (props: GridCellProps) => {
  const { t } = useTranslation();
  const { value } = useGridCellDisplayValue(props);
  const setIsSwapItemModalOpen = useContextSelector(
    ShoppingCartContext,
    (context) => context.setIsSwapItemModalOpen
  );
  const setSwapItemData = useContextSelector(
    ShoppingCartContext,
    (context) => context.setSwapItemData
  );

  const handleSwapItemClick = (
    event: React.MouseEvent<HTMLDivElement> | React.KeyboardEvent<HTMLDivElement>
  ) => {
    event.stopPropagation();
    event.preventDefault();
    setIsSwapItemModalOpen(true);
    setSwapItemData({
      pageType: 1,
      orderBinId: props.dataItem?.clientOrderBinId,
      supplierId: props.dataItem?.supplierId,
      supplierCompanyId: props.dataItem?.supplierCompanyId,
      itemNumber: props.dataItem?.itemNum,
      productId: props.dataItem?.productId,
      catalogId: props.dataItem?.catalogId,
      categoryId: props.dataItem?.categoryId,
      quantity: props.dataItem?.qty,
      price: Number(props.dataItem?.price),
      uom: props.dataItem?.uom,
    });
  };

  const showSwapIcon = Boolean(value);

  return (
    <GridCellBase
      {...props}
      disableToolTip={!showSwapIcon}
      title={showSwapIcon ? t('Check Contracted Alternatives') : undefined}
    >
      {showSwapIcon ? (
        <div
          onClick={handleSwapItemClick}
          className="flex cursor-pointer items-center justify-center"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              handleSwapItemClick(event);
            }
          }}
        >
          <NoItemIcon />
        </div>
      ) : null}
    </GridCellBase>
  );
};

export default ShoppingCartSwapItem;
